import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Footer from '../components/homepage/Footer';

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#EAF0F6',
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: '#fff3e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 32, color: '#ef6c00' }} />
      </Box>
      <Typography variant="h5" fontWeight={800} color="#072146">
        Access Restricted
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center" maxWidth={340}>
        You don't have permission to view this page. Contact your space administrator if you think this is a mistake.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={{ mt: 1, bgcolor: '#072146', '&:hover': { bgcolor: '#0a326d' }, borderRadius: 2, textTransform: 'none', fontWeight: 700 }}
      >
        Back to Dashboard
      </Button>

    </Box>
  );
}
